/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const FiscalProvider = {
    WEBKASSA: 'WEBKASSA',
    PLATFORMA_OFD: 'PLATFORMA_OFD'
} as const;
export type FiscalProvider = typeof FiscalProvider[keyof typeof FiscalProvider];

